
































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { getStatusBarHeight } from "@/utils/js_bridge_info";

@Component({
  components: {}
})
export default class NavBar extends Vue {
  @Prop({ default: false })
  private transparent?: boolean;
  @Prop({ default: false })
  private border?: boolean;
  @Prop({ default: "" })
  private leftType?: string;
  @Prop({ default: false })
  private leftFork?: boolean;
  @Prop({ default: false })
  private flowLayout?: boolean;

  get statusBarHeight() {
    return `padding-top:${getStatusBarHeight()}px`;
  }

  private clickLeft() {
    this.$emit("clickLeft");
  }

  private clickMid() {
    this.$emit("clickMid");
  }

  private clickRight() {
    this.$emit("clickRight");
  }
}
